import { mapAffiliationToCode, mapRegTypeToCode, mapRoleTypeToCode } from "./registrationOptions";

export const isRegistrationFormValid = ({ name, institution, roleTypeNumeric, regTypeNumeric, agreement, needTimeNumeric, agendaTopic, agendaTime }) => {
  const hasRequiredFields = Boolean(name?.trim()) && Boolean(institution?.trim()) && roleTypeNumeric !== "1" && regTypeNumeric !== "1" && agreement.length > 0;
  const hasAgendaIfNeeded = needTimeNumeric !== "2" || (Boolean(agendaTopic?.trim()) && Boolean(agendaTime?.trim()));
  return hasRequiredFields && hasAgendaIfNeeded;
};

export const buildRegistrationPayload = ({ conference, name, institution, email, roleTypeNumeric, regTypeNumeric, affiliation, agreement, needTimeNumeric, agendaTopic, agendaTime }) => ({
  conference_name: conference,
  name,
  institution,
  email,
  role: mapRoleTypeToCode(roleTypeNumeric),
  registration_type: mapRegTypeToCode(regTypeNumeric),
  affiliation: mapAffiliationToCode(affiliation),
  agreement: agreement[0] === 1,
  need_time: needTimeNumeric === "2",
  agenda_topic: agendaTopic,
  agenda_time: agendaTime,
});

export const applyConferenceRules = (payload, { conference, currentPreventMeeting }) => {
  const adjusted = { ...payload };
  if (conference === "palicc_prevent_symposium_2022") {
    adjusted.need_time = false;
    adjusted.agenda_topic = "";
    adjusted.agenda_time = "";
  }
  if (conference === currentPreventMeeting) adjusted.affiliation = [];
  return adjusted;
};
